import TableBackground from '../../components/Background/TableBackground';
import ActionButton from '../../components/Button/ActionButton/ActionButton';
import { GAME_FIRST_INITIALIZED_KEY } from '../game_state_defs';
import './main-menu.css';

interface MainMenuProps {
    playGameCb: () => void;
    openCreditsCb: () => void;
}

function MainMenu(props: MainMenuProps) {
    const { playGameCb, openCreditsCb } = props;

    return (
        <TableBackground>
            <div className="main-menu">
                <div className="game-title">
                    First World
                    <br />
                    Problems
                </div>
                <div className="menu-buttons">
                    <ActionButton
                        onClick={() => {
                            playGameCb();
                            // Indicate that this is the first playthrough,
                            // so we should be re-initializing the intro dialogue.
                            window.localStorage.setItem(
                                GAME_FIRST_INITIALIZED_KEY,
                                'true'
                            );
                        }}
                        isMenuButton
                    >
                        Play
                    </ActionButton>
                    <ActionButton onClick={openCreditsCb} isMenuButton>
                        Credits
                    </ActionButton>
                </div>
            </div>
        </TableBackground>
    );
}

export default MainMenu;
